import { RestrictedByTooltip } from "components";
import { Button } from "components/buttons/button/Button";
import { RolePermissions, RouteNames } from "enums";
import Restricted from "features/Application/Restricted";
import { type FC } from "react";
import { useNavigate } from "react-router";
import { Tooltip } from "components/common/tooltip";

interface CreateCampaignSendButtonProps {
  id: number;
  disabled: boolean;
}

export const CreateCampaignSendButton: FC<CreateCampaignSendButtonProps> = ({ id, disabled }) => {
  const navigate = useNavigate();

  const onCreateBtnClick = () => navigate(`/${RouteNames.contentSimulatedPhishingCampaigns}/${id}/sends/create`);

  const renderCreateCampaignSendButton = (hasAnyPermission: boolean): React.ReactElement =>
    !hasAnyPermission ? (
      <RestrictedByTooltip hasPermission={hasAnyPermission}>
        <Button primary onClick={onCreateBtnClick} disabled className="create-button">
          Create Send
        </Button>
      </RestrictedByTooltip>
    ) : (
      <Tooltip
        target={
          <Button primary onClick={onCreateBtnClick} disabled={disabled} className="create-button">
            Create Send
          </Button>
        }
        content={"To send Phishing Campaign, it must be published."}
        position="left center"
        styles={{ width: "17rem" }}
        hideOnScroll
        showAlways={disabled}
      />
    );

  return (
    <Restricted
      permissions={[RolePermissions.CampaignsManage]}
      renderContent={(hasAnyPermission: boolean) => renderCreateCampaignSendButton(hasAnyPermission)}
    />
  );
};
